import { render, staticRenderFns } from "./CatalogPagination.vue?vue&type=template&id=681fb286&scoped=true"
import script from "./CatalogPagination.vue?vue&type=script&lang=ts"
export * from "./CatalogPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fb286",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowNarrowLeft: require('/codebuild/output/src1993466134/src/acredo-website/components/icon/iconArrowNarrowLeft.vue').default,IconArrowNarrowRight: require('/codebuild/output/src1993466134/src/acredo-website/components/icon/iconArrowNarrowRight.vue').default})
